import * as HTTP from "./base";

const endpoint = "company";

const getAll = async (queryString = "") => {
  return await HTTP.get(`${endpoint}${queryString}`);
};

const post = async (data) => {
  return await HTTP.post(endpoint, data);
};

const getById = async (id) => {
  return await HTTP.get(`${endpoint}/${id}`);
};

const update = async (id, data) => {
  return await HTTP.put(`${endpoint}/${id}`, data);
};

const destroy = async (id) => {
  return await HTTP.destroy(`${endpoint}/${id}`);
};

const getAllShipping = async (id) => {
  return await HTTP.get(`${endpoint}/${id}/shipping`);
};
const postShipping = async (id, data) => {
  return await HTTP.post(`${endpoint}/${id}/shipping`, data);
};
const getByIdShipping = async (idCompany, idShipping) => {
  return await HTTP.get(`${endpoint}/${idCompany}/shipping/${idShipping}`);
};
const updateShipping = async (id, idShipping, data) => {
  return await HTTP.put(`${endpoint}/${id}/shipping/${idShipping}`, data);
};
const destroyShipping = async (id, idShipping) => {
  return await HTTP.destroy(`${endpoint}/${id}/shipping/${idShipping}`);
};

const getAllUser = async (id) => {
  return await HTTP.get(`${endpoint}/${id}/users`);
};
const postUsersBatch = async (id, data) => {
  return await HTTP.post(`${endpoint}/${id}/users-batch`, data);
};
const destroyUser = async (id, idUser) => {
  return await HTTP.destroy(`${endpoint}/${id}/users/${idUser}`);
};

export {
  getAll,
  post,
  getById,
  update,
  destroy,
  getAllShipping,
  postShipping,
  updateShipping,
  destroyShipping,
  getByIdShipping,
  getAllUser,
  postUsersBatch,
  destroyUser,
};
